module.exports = __webpack_public_path__ + "static/media/arrow-to-top.9d18d96b.svg";